import { Button } from "@gigpro/ui/Button";
import { Link } from "@tanstack/react-router";
import EmptyStateIcon from "components/CommonUIStates/EmptyState.svg?react";
import { House } from "lucide-react";
import React from "react";

export const NotFound: React.FC = () => (
  <div className="flex h-full flex-col items-center justify-center bg-white p-10 text-center">
    <EmptyStateIcon className="mb-8 h-24 w-auto text-black sm:h-32" />
    <h1 className="mb-1 text-enormous font-semibold">Page not found</h1>
    <p className="mb-8 text-large text-gray">The page you're looking for doesn't exist or may have moved.</p>
    <Button asChild variant="contained" className="px-8">
      <Link to="/">
        <House />
        Home
      </Link>
    </Button>
  </div>
);
